import { render, staticRenderFns } from "./AdditionalWorkShifts.vue?vue&type=template&id=9f197d26&"
import script from "./AdditionalWorkShifts.vue?vue&type=script&lang=js&"
export * from "./AdditionalWorkShifts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtn,QTooltip,QSeparator,QInnerLoading,QSpinnerGears} from 'quasar'
component.options.components = Object.assign({QBtn,QTooltip,QSeparator,QInnerLoading,QSpinnerGears}, component.options.components || {})
